export const DAYS = ["Sun", "Mon", "Tues", "Wed", "Thur", "Fri", "Sat"];

export const WEST_ANAHEIM_HOSPITAL = "West Anaheim";
